import React from 'react'
import { AuthenticatedAppProviders } from './context'
import { AppHeader, SideBar, AppLayout, AppMain } from 'components'

import {AuthenticatedRoutes} from './routes'

function AuthenticatedApp({user}) {
	return (
		<AuthenticatedAppProviders>
			<AppHeader />
			<AppLayout>
				<SideBar user={user} />
				<AppMain>
					<AuthenticatedRoutes />
				</AppMain>
			</AppLayout>
		</AuthenticatedAppProviders>
	)
}

export default AuthenticatedApp
